/* CODE1C — Contact Form Pro runtime
   One cacheable, idempotent authority for all rendered Contact Form Pro sections. */
(function () {
  function initShell(shell) {
    if (!shell || shell.dataset.cbhContactInitialised === 'true') return;

    var root = shell.querySelector('form.cbh-contact-pro__form');
    if (!root) return;

    shell.dataset.cbhContactInitialised = 'true';

    var submitButton = root.querySelector('[data-submit-button]');
    var status = root.querySelector('[data-form-status]');
    if (status) {
      window.requestAnimationFrame(function () {
        status.focus();
      });
    }

    root.addEventListener('submit', function () {
      if (!submitButton) return;
      submitButton.disabled = true;
      submitButton.textContent = shell.dataset.sendingLabel || submitButton.textContent;
    });

    var reason = root.querySelector('[data-reason-select]');
    var help = root.querySelector('[data-reason-help]');
    if (!reason || !help) return;

    var defaultText = help.textContent;
    var contextFields = root.querySelectorAll('[data-context-field]');

    function updateContext(context) {
      contextFields.forEach(function (field) {
        var active = context && context !== 'none' && field.getAttribute('data-context-field') === context;
        var input = field.querySelector('input');
        field.hidden = !active;
        if (input) input.disabled = !active;
      });
    }

    function update() {
      var opt = reason.options[reason.selectedIndex];
      var desc = opt && opt.getAttribute('data-desc');
      var context = opt && opt.getAttribute('data-context');
      help.textContent = desc && desc.trim() ? desc : defaultText;
      updateContext(context);
    }

    if (shell.dataset.contactJourney === 'true') {
      var requestedReason = new URLSearchParams(window.location.search).get('reason');
      if (requestedReason) {
        var matchedOption = Array.prototype.find.call(reason.options, function (option) {
          return option.value.toLowerCase() === requestedReason.toLowerCase();
        });
        if (matchedOption) reason.value = matchedOption.value;
      }
    }

    reason.addEventListener('change', update);
    update();
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches('[data-cbh-contact-form-shell]')) initShell(context);
    context.querySelectorAll('[data-cbh-contact-form-shell]').forEach(initShell);
  }

  window.CBHContactFormPro = window.CBHContactFormPro || { initAll: initAll };
  window.CBHContactFormPro.initAll(document);

  if (!window.CBHContactFormPro.sectionListenerBound) {
    document.addEventListener('shopify:section:load', function (event) {
      window.CBHContactFormPro.initAll(event.target);
    });
    window.CBHContactFormPro.sectionListenerBound = true;
  }
})();
